/**
 * @file api-admin-roles.ts
 * @description Обёртка над `GET /admin/roles?category=...` (phase04 шаг 6).
 */

import { apiFetch } from "./api-client";

export interface AdminRole {
  id: string;
  code: string;
  displayName: string;
  category: "PLATFORM" | "SHOP";
  isSuperrole: boolean;
  permissions: string[];
}

export function listAdminRoles(category?: "PLATFORM" | "SHOP"): Promise<AdminRole[]> {
  const qs = category ? `?category=${category}` : "";
  return apiFetch<AdminRole[]>(`/admin/roles${qs}`);
}
